import { Modal } from 'react-bootstrap';
import { parse } from 'json2csv';

export const SalesSummaryModalView = ({ selectedSales, selectedStock, brand, setShowSalesModal, setSelectedSales, setSelectedStock, stateStockTable, stockArray, requestSort, totals }) => {
    console.log(stockArray)
    function convertToCSV() {
        const fields = [
            'productTitle',
            'merchoidQty',
            'merchoidCostPrice',
            'merchoidSalesQty',
            'merchoidSalesValue',
            'merchoidStockValue',
            'aaaSalesValue',
            'aaaSalesQty',
            'aaaStockValue',
            'combinedStockValue',
            'combinedSalesValue',
            'combinedStockCombinedSales',
            'ratio'
        ];
        const opts = { fields };
        const csv = parse(stockArray, opts);
       return csv;
    }



    return (
        <Modal show={true} onHide={() => { }}>

            <Modal.Dialog style={{ width: '80vw', position: 'absolute', top: '10%', left: '50%', transform: 'translate(-50%, 0)', maxWidth: 'unset' }}>


                <Modal.Header >
                    <Modal.Title>{brand} Sales Summary</Modal.Title>
                    <button type="button" class="btn-close bi" aria-label="Close" onClick={() => setShowSalesModal(false)}>

                    </button>
                </Modal.Header>
                <Modal.Body style={{ overflowY: 'auto' }}>
                    <div className="dropdown-group">
                        <div>
                            <label htmlFor="salesDropdown">Sales:</label>
                            <select id="salesDropdown" value={selectedSales} onChange={(e) => setSelectedSales(e.target.value)}>
                                <option value="All Sales">All Sales</option>
                                <option value="AAA Sales">AAA Sales</option>
                                <option value="Merchoid Sales">Merchoid Sales</option>
                            </select>
                        </div>
                        <div>
                            <label htmlFor="stockDropdown">Stock:</label>
                            <select id="stockDropdown" value={selectedStock} onChange={(e) => setSelectedStock(e.target.value)}>
                                <option value="All Stock">All Stock</option>
                                <option value="AAA Stock">AAA Stock</option>
                                <option value="Merchoid Stock">Merchoid Stock</option>
                            </select>
                        </div>
                    </div>

                    <button
                        className="btn btn-primary"
                        style={{ marginBottom: '1rem' }}
                        onClick={() => {
                            console.log(stockArray)
                            const csv = convertToCSV(stockArray);
                            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                            const url = URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'sales-summary.csv');
                            link.click();
                        }}

                    >
                        Export CSV
                    </button>
                    <table>
                        <thead>

                            <tr>
                                <th onClick={() => requestSort('sku')}>SKU</th>
                                <th onClick={() => requestSort('productTitle')}>
                                    Product Title{' '}

                                </th>
                                {(selectedStock === 'All Stock' || selectedStock === 'Merchoid Stock') && (
                                    <>
                                        <th onClick={() => requestSort('merchoidQty')}>Merchoid Stock Qty</th>
                                        <th>Merchoid Cost Price</th>
                                        <th onClick={() => requestSort('merchoidStockValue')}>Merchoid Stock Value</th>
                                    </>
                                )}
                                {(selectedStock === 'All Stock' || selectedStock === 'AAA Stock') && (
                                    <>
                                        <th>AAA Stock Qty</th>
                                        <th>AAA Cost Price</th>
                                        <th onClick={() => requestSort('aaaStockValue')}>AAA Stock Value</th>
                                    </>
                                )}
                                {(selectedSales === 'Merchoid Sales' || selectedSales === 'All Sales') && (
                                    <>
                                        <th onClick={() => requestSort('merchoidSalesQty')}>Merchoid Sales Qty</th>
                                        <th onClick={() => requestSort('merchoidSalesValue')}>Merchoid Sales Value</th>
                                    </>
                                )}


                                {(selectedSales === 'AAA Sales' || selectedSales === 'All Sales') && (
                                    <>
                                        <th onClick={() => requestSort('aaaSalesQty')}>AAA Sales Qty</th>
                                        <th onClick={() => requestSort('aaaSalesValue')}>AAA Sales Value</th>
                                    </>
                                )}


                                {selectedSales === 'All Sales' && <th onClick={() => requestSort('combinedSalesValue')}>Combined Sales Value</th>}
                                {selectedStock === 'All Stock' && <th onClick={() => requestSort('combinedStockValue')}>Combined Stock Value</th>}

                                {<th onClick={() => requestSort('ratio')}>Ratio</th>}


                            </tr>
                        </thead>
                        <tbody>
                            {stateStockTable}
                            <tr>
                                <td>{ }</td>
                                <td>{console.log({ totals })}</td>
                                {(selectedStock === 'All Stock' || selectedStock === 'Merchoid Stock') && (
                                    <>
                                        <td><strong>{totals.merchoidQty}</strong></td>
                                        <td><strong></strong></td>
                                        <td><strong>£{totals.merchoidStockValue.toFixed(2)}</strong></td>
                                    </>
                                )}
                                {(selectedStock === 'All Stock' || selectedStock === 'AAA Stock') && (
                                    <>
                                        <td><strong>{totals.aaaQty}</strong></td>
                                        <td><strong></strong></td>
                                        <td><strong>£{totals.aaaStockValue.toFixed(2)}</strong></td>
                                    </>
                                )}
                                {(selectedSales === 'Merchoid Sales' || selectedSales === 'All Sales') && (
                                    <>
                                        <td><strong>{totals.merchoidSalesQty}</strong></td>
                                        <td><strong>£{totals.merchoidSalesValue.toFixed(2)}</strong></td>
                                    </>
                                )}
                                {(selectedSales === 'AAA Sales' || selectedSales === 'All Sales') && (
                                    <>
                                        <td><strong>{totals.aaaSalesQty}</strong></td>
                                        <td><strong>£{totals.aaaSalesValue.toFixed(2)}</strong></td>
                                    </>
                                )}
                                {selectedSales === 'All Sales' && <td><strong>£{totals.combinedSalesValue.toFixed(2)}</strong></td>}
                                {selectedStock === 'All Stock' && <td><strong>£{totals.combinedStockValue.toFixed(2)}</strong></td>}
                                <td>{}</td>
                            </tr>



                        </tbody>

                    </table>
                </Modal.Body>
            </Modal.Dialog>
        </Modal>
    );
}